import { render } from "./pca-button-dictionary.vue?vue&type=template&id=69e98484&scoped=true"
import script from "./pca-button-dictionary.vue?vue&type=script&setup=true&lang=js"
export * from "./pca-button-dictionary.vue?vue&type=script&setup=true&lang=js"

import "./pca-button-dictionary.vue?vue&type=style&index=0&id=69e98484&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69e98484"],['__file',"src/views/contracts/print-contract/components/pca-button-dictionary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "69e98484"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('69e98484', __exports__)) {
    api.reload('69e98484', __exports__)
  }
  
  module.hot.accept("./pca-button-dictionary.vue?vue&type=template&id=69e98484&scoped=true", () => {
    api.rerender('69e98484', render)
  })

}


export default __exports__